// extracted by mini-css-extract-plugin
module.exports = {"content":"LifestyleLayout_content__xJ2g6"};